export const config = {
  title: 'Revamping\nthe educational\nprocess\nmanagement\nsoftware',
  image: {
    src: '/images/cases/education/education-management-header-image.webp',
    alt: 'Revamping the educational process management software',
    width: 2500,
    height: 720,
  },
}
